export type FirebaseWebClientConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};

export const FIREBASE_CLIENT_BY_PROJECT_ID = {
  "goodsender-prod": {
    apiKey: "AIzaSyDozuDy0cQjOJWEbaGWIiF1ATQph3i-vRU",
    // Firebase Auth serves the OAuth popup handler (/__/auth/handler) only from
    // a domain backed by Firebase Hosting. Since prod's goodsender.com moved to
    // App Hosting (SSR), that path 404s there and signInWithPopup fails — so we
    // point authDomain at the always-Hosting-backed default project domain,
    // which still serves the handler. goodsender.com stays an authorized OAuth
    // domain (the app origin); firebaseapp.com is authorized by default.
    authDomain: "goodsender-prod.firebaseapp.com",
    projectId: "goodsender-prod",
    storageBucket: "goodsender-prod.firebasestorage.app",
    messagingSenderId: "158807752581",
    appId: "1:158807752581:web:36c3ae30991e1fb6f90eec",
    measurementId: "G-YJ7Q1SRDF6",
  },
  "goodsender-dev": {
    apiKey: "AIzaSyA8X5glb79QTlz56w3v16OBQo4kWsgOzMA",
    authDomain: "goodsender-dev.firebaseapp.com",
    projectId: "goodsender-dev",
    storageBucket: "goodsender-dev.firebasestorage.app",
    messagingSenderId: "830171507725",
    appId: "1:830171507725:web:15b70e30b3b8b90d65b944",
    measurementId: "G-PFKQQW4E4H",
  },
} satisfies Record<string, FirebaseWebClientConfig>;

export function getFirebaseClientConfig(
  projectId: string,
): FirebaseWebClientConfig {
  if (projectId in FIREBASE_CLIENT_BY_PROJECT_ID) {
    return FIREBASE_CLIENT_BY_PROJECT_ID[
      projectId as keyof typeof FIREBASE_CLIENT_BY_PROJECT_ID
    ];
  }
  throw new Error(`Unknown Firebase project: ${projectId}`);
}
